import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyView = (eventCategory: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "view",
        event_category: eventCategory
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyView = (eventCategory: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "view",
        event_category: eventCategory
    };

    hitGoogleTagManager(gtmData);
};
